import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import BookProvider from '../lib/bookProvider';

class Player extends PureComponent {
  static propTypes = {
    playing: PropTypes.bool.isRequired,
    currentTime: PropTypes.number.isRequired,
    score: PropTypes.object,
    debug: PropTypes.bool,
    karaoke:PropTypes.bool,
    // CALLBACKS:
    onAudioTimeUpdate: PropTypes.func,
    onTuneLoaded: PropTypes.func,
    onPlaybackFinished: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      baseUrl: null,
      melodyUrl: null,
      drumNote: 'A1'
    };

    this.baseAudioPlayerRef = React.createRef();
    this.melodyAudioPlayerRef = React.createRef();
    this.metronomeRef = React.createRef();
  }

  //shouldComponentUpdate(nextProps, nextState, nextContext) {
  //}

  render() {
    const { debug } = this.props;
    const { drumNote, baseUrl, melodyUrl } = this.state;
    if (!melodyUrl) return <div>Loading audio files...</div>;
    let url = melodyUrl;
    if(this.props.karaoke === true){
      url = url.replace('melodia.mp3','karaoke.mp3');
    }
    return (
      <div>
        {debug && (
          <select value={this.state.drumNote} onChange={this.handleDrumChange}>
            {Object.entries(window.MIDI.Soundfont.percussion).map((x, i) => {
              return (
                <option key={'drum' + i} value={x[0]}>
                  {x[0]}
                </option>
              );
            })}
          </select>
        )}
        {baseUrl && (
          <audio
            ref={this.baseAudioPlayerRef}
            src={process.env.PUBLIC_URL + baseUrl}
            controls
            onTimeUpdate={this.onAudioTimeUpdate}
            style={{ display: 'none' }}
            onCanPlay={this.updateMuted}
          />
        )}
        <audio
          ref={this.melodyAudioPlayerRef}
          src={process.env.PUBLIC_URL + url}
          controls
          onTimeUpdate={this.onAudioTimeUpdate}
          style={{ display: 'none' }}
          onCanPlay={this.updateMuted}
        />
        <audio ref={this.metronomeRef} src={window.MIDI.Soundfont.percussion[drumNote]} />
      </div>
    );
  }

  componentDidMount() {
    if (this.props.score) this.loadMusic(this.props.score);
  }

  componentWillReceiveProps(nextProps) {
    const { playing, currentTime, score } = nextProps;
    if (currentTime !== this.props.currentTime || playing !== this.props.playing) {
      this.updatePlayStatus(playing, currentTime);
    }
    if (score !== this.props.score) this.loadMusic(score);
  }

  updatePlayStatus = (playing, currentTime) => {
    if (playing === this.props.playing && currentTime !== 0) return;
    if (!playing) this.melodyAudioPlayerRef.current.pause();
    if (currentTime === 0) {
      this.melodyAudioPlayerRef.current.pause();
      this.melodyAudioPlayerRef.current.currentTime = 0.0;
    }
    if (playing) this.melodyAudioPlayerRef.current.play();
  };

  loadMusic = score => {
    const { baseUrl, melodyUrl } = BookProvider.getMusicUrls(score);
    this.setState({ baseUrl: baseUrl, melodyUrl: melodyUrl });
  };

  handleDrumChange = event => {
    const mode = event.target.value;
    this.metronomeRef.current.src = window.MIDI.Soundfont.percussion[mode];
    this.setState({ drumNote: mode });
  };

  handleBPMChange = rate => {
    this.resetTune();
    //this.baseAudioPlayerRef.current.playbackRate = rate;
    this.melodyAudioPlayerRef.current.playbackRate = rate;
  };

  onAudioTimeUpdate = () => {
    const { onAudioTimeUpdate } = this.props;
    if (onAudioTimeUpdate) onAudioTimeUpdate(this.melodyAudioPlayerRef.current.currentTime);
  };

  updateMuted = () => {
    const { onTuneLoaded } = this.props;
    if (onTuneLoaded) onTuneLoaded(this.melodyAudioPlayerRef.current.duration);
  };
}

export default Player;
